import { EOfficeType } from 'shared/types/filters';

export const EXCLUDED_SALE_OFFICE_TYPES = [EOfficeType.Coworking, EOfficeType.Workplace];
